import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { PersonnelSearchViewModel } from "src/erp/enterpriseAdministration/humanResource/personnel/personnelSearch/personnelSearch-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IUser } from "../iUser";
import  { UserEditorView } from "./userEditor-view"

export class UserEditorViewModel extends ViewModel implements IUser,IPopup{
    constructor(parentViewModel: ViewModel,updater : IServerUpdater) {
        super(parentViewModel);

        this.personnelSelector = new PersonnelSearchViewModel(this);
        this.personnelSelector.onSelectionChanged = x=>{
            this.personnelCode = x.code;
            this.personnelFullName = `${x.name} ${x.lastName}`;
            this.personnelId = x.id;
        }
        this._updater = updater;
    }
    closePopup(result?: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new UserEditorView();
    }
    public getTypeId(): string {
        return "VM-09067201-6CB7-4247-8929-220307D0E35F"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set repeatPassword(v: string) { this._repeatPassword = v; } public get repeatPassword(): string { return this._repeatPassword;} private _repeatPassword: string;
    public set personnelSelector(v: PersonnelSearchViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSearchViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSearchViewModel;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName;} private _personnelFullName: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;
                

    getPassword(): string {
        return this.password;
    }

    private _updater:IServerUpdater;

    cloneTo(user: IUser) {
        user.id = this.id;
        user.username = this.username;
        user.personnelId = this.personnelId;    
    }
    back(){
        this.closePopup(null);
    }

    async save(){
        let verificationResult = this.verify();
        if(verificationResult.length>0){
            this.messageBoxConfirmWarning(verificationResult.join('\n'),'خطا در ثبت کاربر');
            return;
        }else{
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess('کاربر با موفقیت ثبت شد.','ثبت موفق');
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت کاربر','خطا در عملیات');
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify():string[]{
        let result :string[] = [];
        if(stringIsNullOrEmpty(this.username)){
            result.push('نام کاربری مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.password)){
            result.push('رمز عبور مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.repeatPassword)){
            result.push('تکرار رمز عبور مشخص نشده است.')
        }
        if(this.password!==this.repeatPassword){
            result.push('رمز عبور و تکرار آن یکسان نیست.')
        }
        if(this.personnelSelector.selectedItem==null){
            result.push('کاربر انتخاب نشده است.')
        }
        return result;
    }
}

export interface IServerUpdater{
    execute(personnel:IUser):Promise<any>;
}


export class UserInserter implements IServerUpdater{
    async execute(user: IUser): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/SecurityRawDataServices/CreateUser',{
                PersonnelId : user.personnelId,
                Username : user.username,
                Password : user.getPassword()
            });
            if(result.IsSuccessful==false){
                throw "Error Saving User";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}